export default {
    buttons: {
        upload_xlsx: 'Upload XLSX',
        csv_upload_success: 'All emails changed succesfully!',
    },
    claim_your_profile_modal: {
        heading: '{failedEmailsCount} out of {totalEmailsCount} emails failed to changed!',
        google_sheets_link: 'Go To Google Sheets',
        pcp_placeholder: 'PCP name',
        select_campaign_placeholder: 'Select Campaign',
    },
}
